export function prevLocation() {
    const prevBtn = document.querySelectorAll('.go_to_previous_location');
    prevBtn.forEach((el) => {
        el.addEventListener('click', () => {
            window.history.back ();
        })
    })
}